import { ForwardedRef, forwardRef } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Inventory } from '../../models/Inventory'
import react, { useEffect } from 'react'
import { User } from '../../models/User'
import MenteeInventoryListItemPrint from '../Mentee/Inventory/MenteeInventoryListItemPrint'
import './printPage.css'

type Props = {
  inventories: Inventory[]
  me: User | null
}

// 학생의 Inventory를 강사가 보는 InventoryList
function InventoryListViewStudent(props: Props) {
  const [payMin, setPayMin] = react.useState(0)
  const [payMax, setPayMax] = react.useState(0)
  const [pointMax, setPointMax] = react.useState(0)
  const [likeMax, setLikeMax] = react.useState(0)
  const [recommendMax, setRecommendMax] = react.useState(0)

  useEffect(() => {
    if (!props.inventories) {
      return
    }
    if (props.inventories.length > 0) {
      const minLower: number[] = props.inventories.map(
        (inventory: Inventory) => inventory.job.payLower
      )
      const minUpper: number[] = props.inventories.map(
        (inventory: Inventory) => inventory.job.payUpper
      )
      const maxPoint: number[] = props.inventories.map(
        (inventory: Inventory) => inventory.point
      )
      const maxLike: number[] = props.inventories.map(
        (inventory: Inventory) => inventory.likeCnt
      )
      const maxRecommend: number[] = props.inventories.map(
        (inventory: Inventory) => inventory.recommendCnt
      )

      setPayMin(Math.min(...minLower))
      setPayMax(Math.max(...minUpper))
      const pm = Math.max(...maxPoint)
      setPointMax(pm === 0 ? 1 : pm)
      const lm = Math.max(...maxLike)
      setLikeMax(lm === 0 ? 1 : lm)
      const rm = Math.max(...maxRecommend)
      setRecommendMax(rm === 0 ? 1 : rm)
    }
  }, [props.inventories])

  return (
    <Container>
      <Content className="mentor">
        {props.inventories &&
          props.inventories.length > 0 &&
          props.inventories.map((inventory: Inventory, index: number) => (
            <MenteeInventoryListItemPrint
              key={index}
              inventory={inventory}
              inventories={props.inventories}
              payMin={payMin}
              payMax={payMax}
              pointMax={pointMax}
              recommendMax={recommendMax}
              likeMax={likeMax}
              isShowMemo={true}
              user={props.me}
            />
          ))}
      </Content>
    </Container>
  )
}

const Container = styled.section`
  grid-area: main;
  margin-right: 1rem;
  width: 100%;
  box-sizing: border-box;
  /* padding: 20px; */
  /* @media (max-width: 768px) {
    width: 100%;
  } */
`

const Title = styled.div`
  width: 100%;
  padding: 30px;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
`

const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  row-gap: 20px;
  padding-bottom: 100px;
`
const NotExist = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 100px;
  font-size: 1.2rem;
`

export default InventoryListViewStudent
